export enum DocsUrls {
  PERSONAL_API_TOKENS = 'https://docs.apono.io/reference/getting-started-using-apono-api',
  ACCESS_FLOWS = 'https://docs.apono.io/docs/access-flow',
  ACCESS_BUNDLES = 'https://docs.apono.io/docs/access-bundles',
  CONNECTOR_MANAGEMENT = 'https://docs.apono.io/docs/connector-management',
  WEBHOOKS = 'https://docs.apono.io/docs/webhooks',
}
